import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ModuleRenderingListResponse, ModuleRenderingQueryParams, SlotRenderingListResponse, SlotRenderingQueryParams } from '@frontend/common-types';

export class SpotRenderingClient extends APIClient {
    public static readonly endpoint = '/spot-api/ext/v1';

    public static async fetchSpotRendering(
        accountId: string,
        spotId: string,
        queryParams?: ApiQueryParams<SlotRenderingQueryParams>
    ): Promise<ModuleRenderingListResponse> {
        return await this.apiPaginated<ModuleRenderingListResponse, SlotRenderingQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/rendering`,
            queryParams
        );
    }

    public static async fetchSpotModuleRendering(
        accountId: string,
        spotId: string,
        moduleId: string,
        queryParams?: ApiQueryParams<ModuleRenderingQueryParams>
    ): Promise<SlotRenderingListResponse> {
        return await this.apiPaginated<SlotRenderingListResponse, ModuleRenderingQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/rendering`,
            queryParams
        );
    }
}
